// extracted by mini-css-extract-plugin
export var content = "_pe-1";
export var fullScreen = "_pe-0";